import { CloudUpload, FolderCheck, BellRing } from "lucide-react";
import { Reveal } from "./Motion";

const STEPS = [
  { Icon: CloudUpload, t: "Drop it in", d: "Upload, snap it with your phone or forward the email. Receipts, policies, wills, manuals — anything on paper." },
  { Icon: FolderCheck, t: "Filed for you, approved by you", d: "Each upload comes back named, categorized and dated, with a confidence badge. One tap re-files it." },
  { Icon: BellRing, t: "It works for you", d: "Renewal reminders, tax packs, a monthly digest — and a plan your family can actually follow." },
];

export const Pillars = () => (
  <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32" data-testid="pillars-section">
    <Reveal className="max-w-2xl">
      <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#B4532A]">How the vault works</div>
      <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1F1A17]">
        Three steps, then it <em>mostly runs itself.</em>
      </h2>
    </Reveal>
    <div className="mt-14 grid md:grid-cols-3 gap-5">
      {STEPS.map(({ Icon, t, d }, i) => (
        <Reveal key={t} delay={i * 0.1}>
          <div data-testid={`pillar-${i}`} className="group relative h-full overflow-hidden rounded-3xl border border-[#E8DDD3] bg-white p-8 transition-transform duration-500 hover:-translate-y-1">
            <div className="absolute -right-3 -top-8 font-serif text-[140px] leading-none text-[#B4532A]/[0.07] select-none">{i + 1}</div>
            <div className="h-12 w-12 rounded-2xl bg-[#FDEEE8] text-[#B4532A] grid place-items-center transition-transform duration-500 group-hover:rotate-[-8deg]">
              <Icon className="h-5 w-5" />
            </div>
            <h3 className="mt-6 text-lg font-semibold text-[#1F1A17]">{t}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#685F58]">{d}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
